<template>
  <div class="dashboard-container">
    <el-collapse v-model="activeNames" @change="saveContentStatus">
      <el-collapse-item :title="$t('admin.rpa.label.51job')" name="1">
        <div class="collapse-container">
          <CounterList
            v-loading="jobPostingData[CHANNEL_ID.JOB_51].loading"
            class="job"
            :titleI18nKey="`${i18nPrefix}.label.job`"
            :data="getCountDataList(CHANNEL_ID.JOB_51, FEATURE_TYPE.JOB_POSTING)"
          >
            <template #titleBtn>
              <Dropdown
                v-model="jobPostingData[CHANNEL_ID.JOB_51].day"
                :data="dayRangeList"
                @change="handelDayChange(CHANNEL_ID.JOB_51, featureTypeJobPosting)"/>
            </template>
          </CounterList>
          <CounterList
            v-loading="resumeData[CHANNEL_ID.JOB_51].loading"
            class="resume"
            :titleI18nKey="`${i18nPrefix}.label.resume`"
            :data="getCountDataList(CHANNEL_ID.JOB_51, FEATURE_TYPE.DOWNLOAD_RESUME)"
            :countArray="[3, 4]"
          >
            <template #titleBtn>
              <Dropdown
                v-model="resumeData[CHANNEL_ID.JOB_51].day"
                :data="dayRangeList"
                @change="handelDayChange(CHANNEL_ID.JOB_51, featureTypeDownload)"/>
            </template>
          </CounterList>
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t('admin.rpa.label.zhilian')" name="2">
        <div class="collapse-container">
          <CounterList
            v-loading="jobPostingData[CHANNEL_ID.ZHI_LIAN].loading"
            class="job"
            :titleI18nKey="`${i18nPrefix}.label.job`"
            :data="getCountDataList(CHANNEL_ID.ZHI_LIAN, FEATURE_TYPE.JOB_POSTING)"
          >
            <template #titleBtn>
              <Dropdown
                v-model="jobPostingData[CHANNEL_ID.ZHI_LIAN].day"
                :data="dayRangeList"
                @change="handelDayChange(CHANNEL_ID.ZHI_LIAN, featureTypeJobPosting)"/>
            </template>
          </CounterList>
          <CounterList
            v-loading="resumeData[CHANNEL_ID.ZHI_LIAN].loading"
            class="resume"
            :titleI18nKey="`${i18nPrefix}.label.resume`"
            :data="getCountDataList(CHANNEL_ID.ZHI_LIAN, FEATURE_TYPE.DOWNLOAD_RESUME)"
            :countArray="[3, 4]"
          >
          <template #titleBtn>
              <Dropdown
                v-model="resumeData[CHANNEL_ID.ZHI_LIAN].day"
                :data="dayRangeList"
                @change="handelDayChange(CHANNEL_ID.ZHI_LIAN, featureTypeDownload)"/>
            </template>
          </CounterList>
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t('admin.rpa.label.liepin')" name="3">
        <div class="collapse-container">
          <CounterList
            v-loading="jobPostingData[CHANNEL_ID.LIE_PIN].loading"
            class="job"
            :titleI18nKey="`${i18nPrefix}.label.job`"
            :data="getCountDataList(CHANNEL_ID.LIE_PIN, FEATURE_TYPE.JOB_POSTING)"
          >
            <template #titleBtn>
              <Dropdown
                v-model="jobPostingData[CHANNEL_ID.LIE_PIN].day"
                :data="dayRangeList"
                @change="handelDayChange(CHANNEL_ID.LIE_PIN, featureTypeJobPosting)"/>
            </template>
          </CounterList>
          <CounterList
            v-loading="resumeData[CHANNEL_ID.LIE_PIN].loading"
            class="resume"
            :titleI18nKey="`${i18nPrefix}.label.resume`"
            :data="getCountDataList(CHANNEL_ID.LIE_PIN, FEATURE_TYPE.DOWNLOAD_RESUME)"
            :countArray="[3, 4]"
          >
          <template #titleBtn>
              <Dropdown
                v-model="resumeData[CHANNEL_ID.LIE_PIN].day"
                :data="dayRangeList"
                @change="handelDayChange(CHANNEL_ID.LIE_PIN, featureTypeDownload)"
               />
            </template>
          </CounterList>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          {{ $t('admin.rpa.label.rpaList') }}
          <el-button v-if="taskBackend === 'legacy'" type="primary" class="add-task-info-button" @click="handleAddTask">
            {{ $t('admin.rpa.btn.add') }}
          </el-button>
        </template>
        <el-tabs :value="taskBackend" @tab-click="handleTaskTabChange">
          <el-tab-pane :label="$t('admin.rpa.label.legacyTasks')" name="legacy" />
          <el-tab-pane :label="$t('admin.rpa.label.newTasks')" name="new" />
        </el-tabs>
        <NoBorderTable
          class="rpa-table"
          :loading="listLoading"
          :noOperation="true"
          :showCreateBtn="false"
          :tableColumns="tableColumns"
          :listData="searchResult"
          :rowClassName="tableRowClassName"
        >
          <template #filter-group>
            <el-select
              v-model="search.taskStatus"
              class="task-status-filter"
              clearable
              :placeholder="$t(`${i18nPrefix}.placeholder.search.taskStatus`)"
              @change="searchTaskLauncherList"
            >
              <el-option v-for="(value, key) in TASK_STATUS" :key="key" :value="value" :label="$t(`${i18nPrefix}.taskStatus.${key}`)"></el-option>
            </el-select>
             <el-select
              v-model="search.launcherStatus"
              class="launcher-status-filter"
              clearable
              :placeholder="$t(`${i18nPrefix}.placeholder.search.launcherStatus`)"
              @change="searchTaskLauncherList"
            >
              <el-option v-for="(value, key) in LAUNCHER_DISPLAY_STATUS" :key="key" :value="value" :label="$t(`${i18nPrefix}.launcherDisplayStatus.${key}`)"></el-option>
            </el-select>
            <el-select
              v-model="search.featureType"
              class="feature-filter"
              clearable
              :placeholder="$t(`${i18nPrefix}.placeholder.search.featureType`)"
              @change="searchTaskLauncherList"
            >
              <el-option
                v-for="(item, index) in featureTypeOptionList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-model="search.keywords"
              class="keywords-filter"
              clearable
              :placeholder="$t(`${i18nPrefix}.placeholder.search.keywords`)"
              @keypress.enter.native="searchTaskLauncherList"
            >
              <template #append>
                <div class="search-btn" @click="searchTaskLauncherList">
                  <i class="el-icon-search"></i>
                </div>
              </template>
            </el-input>
            <el-select
              v-model="search.channel"
              class="channel-filter"
              clearable
              :placeholder="$t(`${i18nPrefix}.placeholder.search.channel`)"
              @change="searchTaskLauncherList"
            >
              <el-option
                v-for="(item, index) in channelOptionList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-select
              v-model="search.company"
              class="company-filter"
              filterable
              clearable
              multiple
              :placeholder="$t(`${i18nPrefix}.placeholder.search.company`)"
              @change="searchTaskLauncherList"
            >
              <el-option v-for="(item, index) in companyList" :key="index" :value="item.id" :label="`${item.id} - ${item.i18nName}`"></el-option>
            </el-select>
          </template>
          <template #hrInfo="{ row }">
            <div class="company-name">{{ row.task.company.i18nName }}</div>
            <div class="hr-email" :title="row.task.account.account">{{ row.task.account.account }}</div>
            <i class="edit-icon el-icon-edit" @click="handleEditTask(row.task_id)"></i>
          </template>
          <template #channel="{ row }">
            <span class="channel-name">{{ row.task.channel.i18nName }}</span>
          </template>
          <template #type="{ row }">
            <span class="type-name">{{ $t(`${i18nPrefix}.featureType.${row.task.feature_type}`) }}</span>
          </template>
          <template #status="{ row }">
            <div class="status-container" :class="row.statusInfo.displayStatus">
              <span v-if="isClosedLauncher(row)" class="close-status">{{ $t(`${i18nPrefix}.launcherDisplayStatus.${row.statusInfo.displayStatus}`) }}</span>
              <span v-else-if="isInQueueLauncher(row)" class="in-queue-status">{{ $t(`${i18nPrefix}.launcherDisplayStatus.${row.statusInfo.displayStatus}`) }}</span>
              <div v-else class="open-status">
                <span class="status-desc">{{ $t(`${i18nPrefix}.launcherDisplayStatus.${row.statusInfo.displayStatus}`) }}</span>
                <div class="data-container">
                  <span class="number">{{ row.activeTime.day }}</span>
                  <div class="date days">{{ $t('admin.rpa.label.table.date.days') }}</div>

                  <span class="number">{{ row.activeTime.hour }}</span>
                  <div class="date hour">{{ $t('admin.rpa.label.table.date.hour') }}</div>

                  <span class="number">{{ row.activeTime.minute }}</span>
                  <div class="date min">{{ $t('admin.rpa.label.table.date.min') }}</div>
                </div>
              </div>
            </div>
          </template>
          <template #action="{ row }">
            <el-popconfirm
              :confirm-button-text='$t(`${i18nPrefix}.message.operatorConfirm`)'
              :cancel-button-text='$t(`${i18nPrefix}.message.operatorCancel`)'
              icon="el-icon-info"
              icon-color="red"
              :disabled="!row.task.can_operate || row.showLoading"
              :title="$t(`${i18nPrefix}.message.operatorConfirmMessage`)"
              @confirm="handelAction(row)"
            >
              <div
                slot="reference"
                class="action-container"
                :class="{ loading: row.showLoading, disable: !row.task.can_operate }"
              >
                <span class="action-icon" :class="row.statusInfo.actionIconClass"></span>
                <span>{{ $t(`${i18nPrefix}.actionType.${row.statusInfo.action}`) }}</span>
                <RectLoading v-show="row.showLoading"/>
              </div>
            </el-popconfirm>
          </template>
          <template #view="{ row }">
            <router-link
              v-if="row.feature_type !== FEATURE_TYPE.GET_JOB_DATA"
              tag="a"
              target="_blank"
              class="view-container"
              :to="`${taskRoutePrefix}/${row.feature_type === FEATURE_TYPE.SHI_XI_SENG_SAVE_RESUME ? 'email-resume' : 'task'}/${row.task_id}/detail?feature=${row.feature_type}`"
            >
              {{ $t('admin.rpa.label.table.header.view') }}
            </router-link>
          </template>
          <template #statusSwitch="{ row }">
            <el-popconfirm
              icon="el-icon-info"
              icon-color="red"
              :disabled="!row.task.can_operate || row.showLoading"
              :title="$t(`${i18nPrefix}.message.operatorConfirmMessage`)"
              :confirm-button-text='$t(`${i18nPrefix}.message.operatorConfirm`)'
              :cancel-button-text='$t(`${i18nPrefix}.message.operatorCancel`)'
              @confirm="handelStatusChange(row)"
            >
              <el-switch
                slot="reference"
                active-color="#007fff"
                :value="row.task.is_enabled"
                :disabled="!row.task.can_operate || row.showLoading"
              ></el-switch>
            </el-popconfirm>
          </template>
        </NoBorderTable>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import NoBorderTable from '@/components/tableList/noBorderTable.vue'
import Dropdown from '@/components/formEditor/dropdown.vue'
import CounterList from './components/counterList.vue'
import RectLoading from '@/components/loading/rectLoading.vue'
import {
  FEATURE_TYPE,
  TASK_STATUS,
  CHANNEL_ID,
  ACTION_TYPE,
  LAUNCHER_STATUS_INFO_MAP,
  LAUNCHER_DISPLAY_STATUS,
  dayRange,
  channelOptionList,
  featureTypeOptionList
} from '@/constant/rpa'
import { addI18nProperty, createI18nProperty } from '@/i18n'

export default {
  props: {
    taskBackend: { type: String, default: 'legacy' }
  },
  components: {
    NoBorderTable,
    Dropdown,
    CounterList,
    RectLoading
  },
  data () {
    return {
      i18nPrefix: 'admin.rpa',
      TASK_STATUS,
      CHANNEL_ID,
      FEATURE_TYPE,
      LAUNCHER_DISPLAY_STATUS,
      channelOptionList,
      featureTypeOptionList,
      activeNames: ['1', '2', '3', '4'],
      jobTimeRange: 0,
      resumeTimeRange: 0,
      autoGetBotActionStatus: false,
      taskLauncherList: [],
      listLoading: false,
      featureTypeJobPosting: FEATURE_TYPE.JOB_POSTING,
      featureTypeDownload: FEATURE_TYPE.DOWNLOAD_RESUME,
      companyList: [],
      search: {
        taskStatus: null,
        launcherStatus: null,
        featureType: null,
        channel: null,
        company: null,
        keywords: null
      },
      searchResult: [],
      jobPostingData: {
        [CHANNEL_ID.JOB_51]: {
          channelId: CHANNEL_ID.JOB_51,
          day: 0,
          countData: {
            posted: 0,
            post_in_queue: 0,
            closed: 0,
            close_in_queue: 0
          },
          loading: false
        },
        [CHANNEL_ID.ZHI_LIAN]: {
          channelId: CHANNEL_ID.ZHI_LIAN,
          day: 0,
          countData: {
            posted: 0,
            post_in_queue: 0,
            closed: 0,
            close_in_queue: 0
          },
          loading: false
        },
        [CHANNEL_ID.LIE_PIN]: {
          channelId: CHANNEL_ID.LIE_PIN,
          day: 0,
          countData: {
            posted: 0,
            post_in_queue: 0,
            closed: 0,
            close_in_queue: 0
          },
          loading: false
        }
      },
      resumeData: {
        [CHANNEL_ID.JOB_51]: {
          channelId: CHANNEL_ID.JOB_51,
          day: 0,
          countData: {
            total: 0,
            processing: 0
          },
          loading: false
        },
        [CHANNEL_ID.ZHI_LIAN]: {
          channelId: CHANNEL_ID.ZHI_LIAN,
          day: 0,
          countData: {
            total: 0,
            processing: 0
          },
          loading: false
        },
        [CHANNEL_ID.LIE_PIN]: {
          channelId: CHANNEL_ID.LIE_PIN,
          day: 0,
          countData: {
            total: 0,
            processing: 0
          },
          loading: false
        }
      },
      channelStatusCount: {}
    }
  },
  computed: {
    taskRoutePrefix () {
      return this.taskBackend === 'new' ? '/v-admin/rpa-new' : '/v-admin/rpa'
    },
    tableColumns () {
      const columns = [
        {
          slotName: 'hrInfo',
          dataKey: 'task.company.i18nName',
          label: this.$t('admin.rpa.label.table.header.companyAccount'),
          width: '165px',
          cellClass: 'hr-info-container',
          sort: {
            enable: true
          }
        },
        {
          label: this.$t('admin.rpa.label.table.header.channel'),
          dataKey: 'task.channel.i18Name',
          slotName: 'channel',
          sort: {
            enable: true
          }
        },
        {
          label: this.$t('admin.rpa.label.table.header.type'),
          dataKey: 'feature_type',
          slotName: 'type',
          sort: {
            enable: true
          }
        },
        {
          label: this.$t('admin.rpa.label.table.header.status'),
          dataKey: 'status',
          slotName: 'status',
          width: '155px'
        },
        {
          label: this.$t('admin.rpa.label.table.header.action'),
          dataKey: 'action',
          slotName: 'action'
        },
        {
          label: this.$t('admin.rpa.label.table.header.view'),
          dataKey: 'view',
          slotName: 'view'
        },
        {
          label: this.$t('admin.rpa.label.table.header.onOff'),
          dataKey: 'status',
          slotName: 'statusSwitch'
        }
      ]
      return columns
    },
    dayRangeList () {
      return _.map(dayRange, item => {
        return { labelI18nKey: `${this.i18nPrefix}.dayRange.${item}`, value: item }
      })
    }
  },
  async created () {
    await this.initData()
  },
  methods: {
    handleTaskTabChange (tab) {
      if (tab.name === this.taskBackend) return
      this.$router.push({ name: tab.name === 'new' ? 'rpaNewDashboardIndex' : 'rpaDashboardIndex' })
    },
    ...mapActions('rpa', ['getTaskList', 'getTaskById', 'updateTask', 'getTaskAction', 'updateTaskAction',
      'getTaskScreenshot', 'getTaskControl', 'getDownloadResumeReportData', 'getPostingJobReportData',
      'changeContentStatus']),
    ...mapGetters('rpa', ['contentStatus']),
    isClosedLauncher (info) {
      return LAUNCHER_STATUS_INFO_MAP[LAUNCHER_DISPLAY_STATUS.CLOSED].statusList.includes(info.status)
    },
    isInQueueLauncher (info) {
      return LAUNCHER_STATUS_INFO_MAP[LAUNCHER_DISPLAY_STATUS.IN_QUEUE].statusList.includes(info.status)
    },
    async initData () {
      this.showLoading = true
      try {
        await Promise.all([
          this.fetchTaskLauncherList(),
          this.initCountData()
        ])
        this.activeNames = this.contentStatus().activeNames
      } finally {
        this.showLoading = false
      }
    },
    async fetchTaskLauncherList () {
      this.listLoading = true
      let taskListResp
      try {
        taskListResp = await this.getTaskList({ taskBackend: this.taskBackend })
      } finally {
        this.listLoading = false
      }
      if (taskListResp) {
        const taskLauncherList = []
        const companyMap = {}
        const now = moment()
        const channelStatusCount = {}
        _.forEach(taskListResp, (taskLauncherInfo) => {
          const taskInfo = taskLauncherInfo.task
          const featureType = taskInfo.feature_type
          const companyInfo = taskInfo.company
          const channelInfo = taskInfo.channel
          const channelId = channelInfo.id
          const channelIdKey = _.findKey(CHANNEL_ID, val => val === channelId)
          createI18nProperty(channelInfo, 'i18nName', `${this.i18nPrefix}.channelName.${channelIdKey}`)
          addI18nProperty(companyInfo, 'i18nName', 'cn_name', 'name')
          companyMap[companyInfo.id] = companyInfo
          const lastStatusInfo = _.last(taskLauncherInfo.status_history)
          let days = 0
          let hours = 0
          let minutes = 0
          if (lastStatusInfo) {
            const statusTime = moment(lastStatusInfo.created_time)
            days = now.diff(statusTime, 'days')
            hours = now.diff(statusTime, 'hours')
            minutes = now.diff(statusTime, 'minutes')
          }
          const activeTime = { day: '00', hour: '00', minute: '00' }
          if (days > 99) {
            activeTime.day = '99'
            activeTime.hour = '99'
            activeTime.minute = '99'
          } else {
            activeTime.day = _.padStart(days, 2, 0)
            activeTime.hour = _.padStart(hours % 24, 2, 0)
            activeTime.minute = _.padStart(minutes % 60, 2, 0)
          }
          taskLauncherInfo.activeTime = activeTime
          Object.defineProperty(taskLauncherInfo, 'statusInfo', {
            configurable: true,
            enumerable: true,
            get () {
              const statusInfo = _.find(LAUNCHER_STATUS_INFO_MAP, ({ statusList }) => statusList.includes(this.status))
              return statusInfo || { displayStatus: LAUNCHER_DISPLAY_STATUS.UNKNOWN }
            }
          })
          taskLauncherInfo.showLoading = false
          taskLauncherList.push(taskLauncherInfo)
          let featureStatusCount = channelStatusCount[channelId]
          if (!featureStatusCount) {
            featureStatusCount = channelStatusCount[channelId] = {}
          }
          let statusCount = featureStatusCount[featureType]
          if (!statusCount) {
            statusCount = featureStatusCount[featureType] = { }
          }
          const displayStatus = taskLauncherInfo.statusInfo.displayStatus
          if (!statusCount.hasOwnProperty(displayStatus)) {
            statusCount[displayStatus] = 0
            statusCount[`${displayStatus}_minutes`] = 0
          }
          statusCount[displayStatus] += 1
          if (statusCount[`${displayStatus}_minutes`] < minutes) {
            statusCount[`${displayStatus}_minutes`] = minutes
          }
        })
        this.taskLauncherList = taskLauncherList
        this.channelStatusCount = channelStatusCount
        this.companyList = _.sortBy(companyMap, 'id')
        this.searchTaskLauncherList()
      }
      this.listLoading = false
    },
    async initCountData () {
      this.refreshJobData(this.jobPostingData[CHANNEL_ID.JOB_51])
      this.refreshJobData(this.jobPostingData[CHANNEL_ID.ZHI_LIAN])
      this.refreshJobData(this.jobPostingData[CHANNEL_ID.LIE_PIN])

      this.refreshResumeData(this.resumeData[CHANNEL_ID.JOB_51])
      this.refreshResumeData(this.resumeData[CHANNEL_ID.ZHI_LIAN])
      this.refreshResumeData(this.resumeData[CHANNEL_ID.LIE_PIN])
    },
    searchTaskLauncherList () {
      this.listLoading = true
      const search = this.search
      this.searchResult = _.filter(this.taskLauncherList, info => {
        const statusInfo = info.statusInfo
        const taskInfo = info.task
        const company = taskInfo.company
        const channel = taskInfo.channel
        let matched = true
        if (matched && search.taskStatus) {
          if (search.taskStatus === TASK_STATUS.DISABLED) {
            matched = taskInfo.can_operate === false
          } else {
            matched = taskInfo.is_enabled === (search.taskStatus === TASK_STATUS.ON)
          }
        }
        if (matched && search.launcherStatus) {
          matched = statusInfo.displayStatus === search.launcherStatus
        }
        if (matched && search.featureType) {
          matched = taskInfo.feature_type === search.featureType
        }
        if (matched && search.channel) {
          matched = channel.id === search.channel
        }
        if (matched && search.company && search.company.length > 0) {
          matched = search.company.includes(company.id)
        }
        if (matched && search.keywords) {
          const keywords = search.keywords.toLowerCase()
          matched = info.task.company.id + '' === keywords
          if (!matched) {
            matched = _.findIndex([
              'task.company.name',
              'task.company.cn_name',
              'task.account.account',
              'task.account.job_51_user_name'
            ], (key) => {
              const val = _.get(info, key)
              return val && typeof val === 'string' && val.toLowerCase().includes(keywords)
            }) > -1
          }
        }
        return matched
      })
      this.listLoading = false
    },
    async refreshJobData (data) {
      data.loading = true
      try {
        data.countData = await this.getPostingJobReportData({
          channel_id: data.channelId,
          days_delta: data.day
        })
      } finally {
        data.loading = false
      }
    },
    async refreshResumeData (data) {
      data.loading = true
      try {
        data.countData = await this.getDownloadResumeReportData({
          channel_id: data.channelId,
          days_delta: data.day
        })
      } finally {
        data.loading = false
      }
    },
    getCountDataList (channelId, featureType) {
      const statusCount = _.get(this.channelStatusCount, `${channelId}.${featureType}`) || {}
      let total = 0
      _.forEach(LAUNCHER_DISPLAY_STATUS, (statusType) => {
        total += statusCount[statusType] || 0
      })
      const activeCount = statusCount[LAUNCHER_DISPLAY_STATUS.ACTIVE] || 0
      const verifyCount = statusCount[LAUNCHER_DISPLAY_STATUS.WAIT_VERIFY] || 0
      const verifyMinutes = statusCount[`${LAUNCHER_DISPLAY_STATUS.WAIT_VERIFY}_minutes`] || 0
      const errorCount = statusCount[LAUNCHER_DISPLAY_STATUS.EXITED_ERROR] || 0
      const errorMinutes = statusCount[`${LAUNCHER_DISPLAY_STATUS.EXITED_ERROR}_minutes`] || 0
      const statusCountDataList = [
        { labelI18nKey: `${this.i18nPrefix}.label.bot.totalBots`, value: total },
        { labelI18nKey: `${this.i18nPrefix}.label.bot.currentBots`, value: activeCount },
        {
          labelI18nKey: `${this.i18nPrefix}.label.bot.needVerifyBots`,
          value: verifyCount,
          minutes: verifyMinutes,
          showRightArrow: verifyCount > 0,
          valueColor: verifyCount > 0 ? '#ee6a6a' : '#67a06f'
        },
        {
          labelI18nKey: `${this.i18nPrefix}.label.bot.errorBots`,
          value: errorCount,
          minutes: errorMinutes,
          showRightArrow: errorCount > 0,
          valueColor: errorCount > 0 ? '#ee6a6a' : '#67a06f'
        }
      ]

      if (featureType === FEATURE_TYPE.JOB_POSTING) {
        const countData = this.jobPostingData[channelId].countData
        const posted = countData?.posted || 0
        const postInQueue = countData?.post_in_queue || 0
        const closed = countData?.closed || 0
        const closeInQueue = countData?.close_in_queue || 0
        return [
          { labelI18nKey: `${this.i18nPrefix}.label.postedJob.new`, value: posted },
          { labelI18nKey: `${this.i18nPrefix}.label.inQueueJob.new`, value: postInQueue },
          { labelI18nKey: `${this.i18nPrefix}.label.postedJob.close`, value: closed },
          { labelI18nKey: `${this.i18nPrefix}.label.inQueueJob.close`, value: closeInQueue },
          ...statusCountDataList
        ]
      } else if (featureType === FEATURE_TYPE.DOWNLOAD_RESUME) {
        const countData = this.resumeData[channelId].countData
        const total = countData?.total || 0
        const handled = countData?.succeed || 0
        return [
          { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.downloaded`, value: total },
          { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.handled`, value: handled },
          { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.gap`, value: total - handled },
          ...statusCountDataList
        ]
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'gray-background'
      }
    },
    toDetailPage (row) {
      if (row && row.task_id) {
        this.$router.push(`${this.taskRoutePrefix}/task/${row.task_id}/detail?feature=${row.feature_type}`)
      }
    },
    handleEditTask (id) {
      if (id) {
        this.$router.push(`${this.taskRoutePrefix}/task/${id}/edit`)
      }
    },
    async handelStatusChange (row) {
      if (!row) {
        return
      }
      row.showLoading = true
      const task = row.task
      const params = {
        id: task.id,
        is_enabled: !task.is_enabled
      }
      try {
        await this.updateTask({ ...params, taskBackend: this.taskBackend })
        task.is_enabled = params.is_enabled
      } finally {
        row.showLoading = false
      }
    },
    async getBotActionStatus (row) {
      // 切换页签会销毁当前页面，停止旧页的轮询，避免读到另一后端。
      if (!this.autoGetBotActionStatus) return
      if (!row || !row.task_id || !row.action_uid) {
        this.autoGetBotActionStatus = false
        return
      }
      row.showLoading = true
      const params = {
        task_id: row.task_id,
        action_uid: row.action_uid
      }
      const resp = await this.getTaskAction({ ...params, taskBackend: this.taskBackend })
      if (!this.autoGetBotActionStatus) return
      if (resp === 'PENDING' && this.autoGetBotActionStatus) {
        setTimeout(this.getBotActionStatus, 1000, row)
      } else {
        row.showLoading = false
        await this.fetchTaskLauncherList()
      }
    },
    toLower (string) {
      return _.toLower(string)
    },
    handleAddTask () {
      this.$router.push({ name: 'rpaAddTask' })
    },
    async handelAction (row) {
      if (!row || !row.task?.is_enabled) {
        return
      }
      this.showLoading = true
      try {
        const action = row.statusInfo.action
        if (!action) {
          return
        }
        if (action === ACTION_TYPE.VERIFY) {
          const detailType = this.taskBackend === 'new' && row.feature_type === FEATURE_TYPE.SHI_XI_SENG_SAVE_RESUME ? 'email-resume' : 'task'
          window.open(`${this.taskRoutePrefix}/${detailType}/${row.task_id}/detail?needVerify=1&?feature=${row.feature_type}`)
        } else {
          const params = {
            task_id: row.task_id,
            action: action
          }
          this.autoGetBotActionStatus = true
          const resp = await this.updateTaskAction({ ...params, taskBackend: this.taskBackend })
          if (resp?.action_uid && this.autoGetBotActionStatus) {
            row.action_uid = resp.action_uid
            this.getBotActionStatus(row)
          }
        }
      } finally {
        this.showLoading = false
      }
    },
    async handelDayChange (channelId, type) {
      if (!channelId || !type) {
        return
      }
      if (type === FEATURE_TYPE.JOB_POSTING) {
        this.refreshJobData(this.jobPostingData[channelId])
      } else if (type === FEATURE_TYPE.DOWNLOAD_RESUME) {
        this.refreshResumeData(this.resumeData[channelId])
      }
    },
    saveContentStatus () {
      const params = {
        name: 'activeNames',
        value: this.activeNames
      }
      this.changeContentStatus(params)
    },
    companyFiltersHandel (value, row) {
      return value === row.task.company.id
    },
    statusFiltersHandel (value, row) {
      return value.includes(row.status)
    }
  },
  destroyed () {
    this.autoGetBotActionStatus = false
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 10px 20px;

  .collapse-container {
    display: flex;
    justify-content: space-between;
    background-color: #f7f7f7;

    > div {
      padding: 15px;
      width: 49%;
      background-color: #FFFFFF;
    }
  }

  .add-task-info-button {
    right: 40px;
    position: absolute;
    padding: 8px 15px;
  }

  .rpa-table {
    padding: 0 10px 25px 10px;

    ::v-deep {
      .table-header {
        height: auto;
        line-height: initial;

        .filter-group {
          flex-wrap: wrap;
          margin-right: 0;
        }
      }
    }

    .filter-group {
      .task-status-filter {
        width: 20%;
        margin-right: 0;
        padding-right: 10px;
      }

      .launcher-status-filter {
        width: 20%;
        margin-right: 0;
        padding-right: 10px;
      }

      .feature-filter {
        width: 20%;
        margin-right: 0;
        padding-right: 10px;
      }

      .keywords-filter {
        width: 40%;
        margin-right: 0;

        .search-btn {
          padding: 0 10px 0 0;
          font-size: 16px;
          cursor: pointer;
        }

        ::v-deep {
          .el-input__inner {
            border-right: 0;
          }

          .el-input-group__append {
            padding: 0;
            border-radius: 0;
            border-color: #b2b2b2;
          }
        }
      }

      .channel-filter {
        width: 20%;
        margin-top: 10px;
        margin-right: 0;
        padding-right: 10px;
      }

      .company-filter {
        width: 80%;
        margin-top: 10px;
        margin-right: 0;
      }
    }

    .hr-info-container {
      .edit-icon {
        font-size: 16px;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      .hr-email {
        min-height: 12px;
        line-height: 1;
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-align: left;
        text-overflow: ellipsis;
      }

      .company-name {
        font-size: 15px;
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-align: left;
        text-overflow: ellipsis;
      }
    }

    .status-container {
      height: 60px;
      border: 2px solid #b0b0b0;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;

      &.WAIT_VERIFY {
        color: #ffd381;
        border-color: #ffd381;

        .data-container {
          border-color: #ffd381;
        }
      }

      &.IN_QUEUE {
        color: #ffd381;
        border-color: #ffd381;
      }

      &.ACTIVE {
        color: #49c23afa;
        border-color: #49c23afa;

        .data-container {
          border-color: #49c23afa;
        }
      }

      &.EXITED_ERROR {
        color: #ee6a6a;
        border-color: #ee6a6a;

        .data-container {
          border-color: #ee6a6a;
        }
      }

      .open-status {
        text-align: left;

        .status-desc {
          color: #606060;
        }
      }

      .close-status {
        font-size: 16px;
      }

      .in-queue-status {
        font-size: 16px;
      }

      .data-container {
        margin-top: 5px;
        padding-top: 3px;
        border-top: 1px solid #b0b0b0;
        display: flex;
        align-items: flex-end;

        .number {
          font-size: 22px;
        }

        .date {
          font-size: 12px;
          color: #606060;
        }
      }
    }

    .action-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      cursor: pointer;

      &.disable {
        cursor: not-allowed;

        .action-icon {
          cursor: not-allowed;
        }
      }

      .action-icon {
        font-size: 24px;
      }

      .iconactive-01 {
        color: #67a06f;
      }

      .iconVerify {
        color: #f99f62;
      }

      .iconrestart-03 {
        color: #ee6a6a;
      }

      &.loading {
        opacity: .5;
      }

      ::v-deep .loading-mask {
        position: absolute;
        background: none;
        background: none;
      }
    }

    .view-container {
      padding: 3px 10px;
      cursor: pointer;
      color: #FFFFFF;
      background-color: #007fff;
    }
  }

  ::v-deep .el-collapse {
    border: 0px;

    .el-collapse-item {
      margin-top: 15px;
    }

    .el-collapse-item__header {
      padding: 0 20px;
      font-size: 16px;
      color: #000000;
      font-weight: 600;
      position: relative;
      border: 0px;

      > i {
        margin-left: 15px;
        transform: rotate(-90deg);

        &.is-active {
          transform: rotate(90deg);
        }
      }
    }

    .el-collapse-item__wrap {
      margin-top: 10px;
      border: 0px;
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    .el-table__header {
      .el-table__cell {
        font-size: 16px;
        padding: 15px 0;
        color: #000000;
        font-weight: 600;

        &.is-leaf {

          &:first-child {
            text-align: left;

            .cell {
              padding: 0 15px;
            }
          }

          background-color: #FFFFFF;
        }
      }

      .el-table__column-filter-trigger {
        i {
          font-size: 18px;
          transform: none;
          vertical-align: middle;
        }
      }
    }

    .el-table__body {
      .el-table__cell {
        padding: 20px 0;

        .cell {
          padding: 0 5px;
        }

        &.hr-info-container {
          .cell {
            padding: 0 10px 0 15px;
            position: relative;
          }
        }
      }

      .gray-background {
        background: #f7f7f7;
      }
    }
  }
}
</style>
